import { render, staticRenderFns } from "./CommonComments.vue?vue&type=template&id=ecb4e2a2&"
import script from "./CommonComments.vue?vue&type=script&lang=js&"
export * from "./CommonComments.vue?vue&type=script&lang=js&"
import style0 from "./CommonComments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports